import React from 'react';
import Task from "../../../../model2/task/task";
import {FieldViewReferenceProps} from "../../../render/view-reference";
import FieldView from "../../../render/view";

export default function FieldTask_ViewReference(props:FieldViewReferenceProps) {

    const task = _.get(props.model, props.field.fieldId, null) as Task

    if (!task) return null

    const onClick = ()=>{
        gd.navigation.goToTask(task.id)
    }

    // max-w-300

    return (
        <div className={Classes("ui5-control-button-36 txt-truncate",props.className)} onClick={onClick}>
            <FieldView field={gd.fields.task.shortId} model={task} className="m-r-8 flex-no-shrink" />
            <FieldView field={gd.fields.task.title} model={task} />
        </div>
    );
}


